import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

export const InFocus = ({ models }) => {
  const picks = models.filter((m) => m.featured).slice(6, 9);
  const list = picks.length === 3 ? picks : models.slice(0, 3);
  if (!list.length) return null;

  return (
    <section data-testid="in-focus" className="border-t border-[#1c1418]/15 bg-white px-5 py-20 text-[#1c1418] md:px-10 md:py-28">
      <div className="mx-auto max-w-[1600px]">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <h2 className="font-display text-5xl uppercase leading-[0.85] md:text-8xl">In Focus</h2>
          <p className="max-w-xs font-serif text-xl italic text-[#1c1418]/75 md:text-right">Three faces from the board, this season.</p>
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {list.map((m, i) => (
            <Reveal key={m.slug} delay={i * 0.1}>
              <Link to={`/models/${m.slug}`} data-testid={`in-focus-${m.slug}`} className="group block">
                <div className="relative aspect-[4/5] overflow-hidden bg-[#eeeeee]">
                  <img src={m.images?.[1] || m.images?.[0]} alt={m.name} loading="lazy"
                    className="h-full w-full object-cover object-top grayscale transition-all duration-700 group-hover:scale-[1.04] group-hover:grayscale-0" />
                </div>
                <div className="mt-4 flex items-center justify-between border-b border-[#1c1418]/15 pb-4">
                  <h3 className="font-display text-4xl uppercase leading-none">{m.name}</h3>
                  <ArrowUpRight className="h-6 w-6 text-[#e9458f] transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
